/** `openTab` search value that mounts the SitStat workspace on the hub map. */
export const SITSTAT_OPEN_TAB = 'SitStat';

/** Search param naming a template to load once SitStat opens. */
export const SITSTAT_TEMPLATE_PARAM = 'sitstatTemplate';

/** Search param naming the AOR whose subtree SitStat should open scoped to. */
export const SITSTAT_AOR_PARAM = 'sitstatAor';
